/**
 * Owner: Haselton Baker Risk Group, LLC
 * Date: 9/14/18
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React, { useState } from 'react';
import { Button, ListGroupItem, Spinner } from 'reactstrap';

export type Download = {|
  type: string,
  name: string,
  path: string,
  extension: string,
|};

type Props = {|
  handleClick: Function,
  download: Download,
|};

const DownloadsListItem = ({ handleClick, download }: Props): Element<typeof ListGroupItem> => {
  const [downloading, setDownloading] = useState(false);

  const onClick = async () => {
    setDownloading(true);
    try {
      await handleClick();
    } catch (e) {
      // Swallowed deliberately: preserves the existing silent-failure behaviour.
    } finally {
      setDownloading(false);
    }
  };

  return (
    <ListGroupItem className="downloads-list-item">
      {download.name}
      {downloading ? (
        <Button color="link" className="float-right" disabled>
          <Spinner size="sm" /> Downloading…
        </Button>
      ) : (
        <Button onClick={onClick} color="link" className="float-right">
          Download
        </Button>
      )}
    </ListGroupItem>
  );
};

export default DownloadsListItem;
